import React from "react";
import { Box, Button, Grid, IconButton, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { css } from "./styles";

export function DownloadOpcoes({ handleClick, toggleModal }) {
    const styles = css();
    return (
        <Grid container className={styles.container}>
            <Box className={styles.header}>
                <Typography className={styles.title}>DOWNLOAD ETIQUETA DE EXPEDIÇÃO</Typography>

                <IconButton className={styles.closeButton} onClick={toggleModal}>
                    <Close />
                </IconButton>
            </Box>

            <Typography className={styles.produtosTitle}>
                Escolha o formato em que deseja fazer o download da etiqueta de expedição:
            </Typography>

            <Box className={styles.buttonsDiv} display="flex" gridGap="20px">
                <Button className={styles.button} onClick={() => handleClick("pdf")}>PDF</Button>
                <Button className={styles.button} onClick={() => handleClick("zpl")}>ZPL</Button>
            </Box>
        </Grid>
    );
}
